import {Component, ComponentRef, Injector, Input, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {IManagableObject} from "../../IManagableObject";
import {KeyViewModel} from "../Model/KeyViewModel";
import {DialogBaseComponent} from "../../base-admin-panel/dialog-base/dialog-base.component";
import {KeysService} from "../../../../services/keys.service";
import {ObjectsManagementDialogComponent} from "../../objects-management-dialog/objects-management-dialog.component";
import {DialogService} from "../../../../services/dialog.service";
import {DriversService} from "../../../../services/drivers.service";
import {ObjectsService} from "../../../../services/objects.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-keys-dialog-base',
    templateUrl: './keys-dialog-base.component.html',
    styleUrls: ['./keys-dialog-base.component.css'],
    standalone: false
})
export class KeysDialogBaseComponent extends DialogBaseComponent<KeyViewModel> implements OnInit {
  @ViewChild("objectsListDialog", { read: ViewContainerRef, static: true }) objectsListContainer;
  private objectsListDialog: ComponentRef<any>;
  @Input()
  public drivers: IManagableObject[] = [];

  public groups: IManagableObject[] = [];

  public openedTabName: string = "main";
  private driversService: DriversService;
  private objectsService: ObjectsService;

  public openTab(name: string) {
    this.openedTabName = name;
  }

  public isSelected(name: string) {
    return name == this.openedTabName;
  }
  @Input()
  public trackers: IManagableObject[] = [];
  protected keysService: KeysService;
  private dialogService: DialogService;

  constructor(protected injector: Injector) {
    super(injector);
    this.keysService = injector.get(KeysService);
    this.dialogService = injector.get(DialogService);
    this.driversService = injector.get(DriversService);
    this.objectsService = injector.get(ObjectsService);
  }


  ngOnInit() {
    super.ngOnInit();
    this.driversService.GetAllDrivers()
      .subscribe(drivers => {
        this.drivers = drivers;
      });

    this.objectsService.GetObjects()
      .subscribe(drivers => {
        this.trackers = drivers;
      });

    this.keysService.GetGroups()
      .subscribe(groups => {
        this.groups = groups;
      });

  }

  public show(id: number)
  {
    this.model = new KeyViewModel();
    this.keysService.GetKey(id)
      .subscribe(key => {
        this.model = key;
        if (this.model)
          this.open(this.model);
      })
  }

  public clearDriver() {
    this.model.DriverId = undefined;
    //this.model.Driver = undefined;
    this.model.DriverName = "";
  }
  public selectDriver() {
    this.objectsListDialog = this.dialogService.open(this.objectsListContainer, ObjectsManagementDialogComponent);
    this.objectsListDialog.instance.isSingleItem = true;
    this.objectsListDialog.instance.onOpen.subscribe(() => {
      this.objectsListDialog.instance.objects = this.drivers;
    });
    this.objectsListDialog.instance.onSubmit.subscribe(() => {

      this.objectsListDialog.instance.objects.forEach(driver => {
        if (driver && driver.IsChecked) {
          this.model.DriverId = driver.Id;
          this.model.DriverName = driver.Name;
          //this.model.Driver = driver;
        }
      });
      this.objectsListDialog.instance.close();
    });
    this.objectsListDialog.instance.onClose.subscribe(() => {
    });
    this.objectsListDialog.instance.open();
  }
}
